import React from 'react';

const BS_Carousel = () => {
    return (
        <div>
            <h1>BS_Carousel Component</h1>
            <p>Content coming soon...</p>
        </div>
    );
}

export default BS_Carousel;
